<div id="forgot-password" fxLayout="column">
    <div id="forgot-password-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
        <div id="forgot-password-form" [@animate]="{ value: '*', params: { duration: '300ms', y: '100px' } }">
            <div class="logo">
                <img src="assets/images/logos/emma-b.png" />
            </div>

            <div class="title">{{ "login.forgotPasswordTitle" | translate }}</div>
            <div class="subtitle">{{ "login.enterEmailToReset" | translate }}</div>

            <form name="forgotPasswordForm" [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPasswordForm.valid && submit()">
                <mat-form-field>
                    <input matInput [placeholder]="'login.email.label' | translate" formControlName="email" />
                    @if (forgotPasswordForm.get("email").hasError("required")) {
                        <mat-error>{{ "login.email.validation.required" | translate }}</mat-error>
                    }
                    @if (!forgotPasswordForm.get("email").hasError("required") && forgotPasswordForm.get("email").hasError("email")) {
                        <mat-error>{{ "login.email.validation.emailFormat" | translate }}</mat-error>
                    }
                </mat-form-field>

                @if (turnstileEnabled) {
                    <div #turnstileContainer class="turnstile-widget"></div>
                }

                @if (success) {
                    <div class="message success">
                        {{ success | translate }}
                    </div>
                }

                @if (error) {
                    <mat-error class="message">
                        {{ error | translate }}
                    </mat-error>
                }

                <button
                    mat-raised-button
                    color="accent"
                    class="submit-button"
                    [disabled]="forgotPasswordForm.invalid || loading || (turnstileEnabled && !captchaToken)"
                >
                    {{ "login.send" | translate }}
                </button>

                <button mat-button type="button" class="secondary-button" (click)="backToLogin()">
                    {{ "login.backToLogin" | translate }}
                </button>
            </form>
        </div>
    </div>
</div>
